const { getElement, getElements } = window.BAO.Utils

export class DrawerQuickBuyGWP extends customElements.get('site-drawer') {
  constructor () {
    super()
    // Used for section rendering API
    this.sectionId = 'quick-buy-gwp'

    if (this.getAttribute('data-drawer-quick-buy-gwp-el') == 'bundle') {
      this.sectionId = 'quick-buy-bundles'
    }
  }

  static get observedAttributes () {
    return ['reinitialise']
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'reinitialise' && newValue === 'true') {
      this.addCartListeners()
    }
  }

  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.addCartListeners.bind(this),
    )

    this.handleTrigger = this.handleTrigger.bind(this)
    this.addCartListeners()
  }

  addCartListeners () {
    document.addEventListener('addGWP', (e) => {
      this.handleTrigger(e.detail)
    })

    this.triggers = getElements('[data-drawer-quick-buy-gwp-external-el="trigger"]')
    this.body = getElement('[data-drawer-quick-buy-gwp-el="body"]', { context: this })

    this.triggers.forEach(trigger => {
      this.listeners.add(trigger, 'click', (event) => this.handleTrigger(event))
    })

    document.addEventListener(window.BAO.EVENTS.PAGINATION.RENDER, () => {
      this.triggers = getElements('[data-drawer-quick-buy-gwp-external-el="trigger"]')

      this.handleTrigger = this.handleTrigger.bind(this)

      this.triggers.forEach(trigger => {
        this.listeners.remove(trigger, 'click', (event) => this.handleTrigger(event))
      })

      this.triggers.forEach(trigger => {
        this.listeners.add(trigger, 'click', (event) => this.handleTrigger(event))
      })

      this.triggers.forEach(trigger => trigger.removeAttribute('hidden'))
    })
  }

  handleTrigger (detail) {
    if (!detail) return

    this.renderDrawerContent(detail)
  }

  async renderDrawerContent (detail) {
    const html = await this.sectionRenderer.fetchSingle(this.sectionId, detail.productUrl)

    const innerHtml = this.sectionRenderer.getInnerHtml(html)
    if (!html || !innerHtml) return

    const parser = new DOMParser()
    const doc = parser.parseFromString(innerHtml, 'text/html')

    const target = doc.querySelector('#product-form-quick-buy-gwp')
    if (target) {
      const hiddenFreeGift = doc.createElement('input')
      hiddenFreeGift.type = 'hidden'
      hiddenFreeGift.name = 'properties[_hiddenFreeGift]'
      hiddenFreeGift.value = 'true'

      const hiddenFreeGiftCookieless = doc.createElement('input')
      hiddenFreeGiftCookieless.type = 'hidden'
      hiddenFreeGiftCookieless.name = 'properties[_hiddenFreeGiftCookieless]'
      hiddenFreeGiftCookieless.value = 'true'

      const messageLabel = doc.createElement('input')
      messageLabel.type = 'hidden'
      messageLabel.name = `properties[${detail.messageLabel}]`
      messageLabel.value = detail.messageContent || ''

      const customPriceText = doc.createElement('input')
      customPriceText.type = 'hidden'
      customPriceText.name = 'properties[_customPriceText]'
      customPriceText.value = detail.customPriceText || ''

      target.appendChild(customPriceText)
      target.appendChild(hiddenFreeGiftCookieless)
      target.appendChild(hiddenFreeGift)
      target.appendChild(messageLabel)

      if (detail.freeGiftStyling != undefined && detail.freeGiftStyling != null) {
        const freeGiftStyling = doc.createElement('input')
        freeGiftStyling.type = 'hidden'
        freeGiftStyling.name = 'properties[_freeGiftStyling]'
        freeGiftStyling.value = detail.freeGiftStyling || ''

        target.appendChild(freeGiftStyling)
      }
    }

    const variantId = localStorage.getItem(`lastGWPVariant${detail.productId}`)

    this.updateBodyContent(doc.body.innerHTML, variantId)
    this.openDrawer()
  }

  openDrawer () {
    getElement('site-drawers')?.open(this.getAttribute('key'))
  }

  closeDrawer () {
    getElement('site-drawers')?.closeDrawer(this.getAttribute('key'))
  }

  updateBodyContent (content, variantId) {
    this.body.innerHTML = ''
    this.body.insertAdjacentHTML('beforeend', content)

    if (variantId) {
      const variantInput = this.querySelector(`input[data-variant-id="${variantId}"]`)
      variantInput?.click()
    }
  }

  /**
   * @returns {sectionRenderer} The BAO sectionRenderer class
   */
  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }
}

customElements.define('drawer-quick-buy-gwp', DrawerQuickBuyGWP)
